import $ from "jquery";

export const init = () => {
  $(".backtotop").on("click", function () {
    return (
      $("html:not(:animated),body:not(:animated)").animate(
        { scrollTop: 0 },
        "normal"
      ),
      !1
    );
  });
};
